import React, {useEffect, useState } from 'react';

import './home.css';

import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';


import PropertyCard from '../../components/property/propertyCard';
import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import {connect} from 'react-redux';
import * as actions from '../../store/property/actions';
import * as locationActions from '../../store/location/actions';
import * as actionsPropertyType from '../../store/propertyType/actions';

import CustomPagination from '../../components/pagination/customPagination';

const SearchPage =({ searchProperties, propertiesResults, getPropertyTypes, propertyTypeWithAttributes, fetchLocations, suggestedLocation}) => {    

    const [ currentPage, setCurrentPage] = useState(1);
    const [ formData, setFormData ] = useState({
        title: '',
        location: '',
        property_type: '',
        property_type_id: ''
    });
    const [propertyTypes, setPropertyTypes] = useState('');
    const [ propertyTypeSubCategory, setPropertyTypeSubCategory ] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [ resultText, setResultText ] = useState('');
    const [ activeLocationId, setActiveLocationID ] = useState();

    useEffect(() => {
		loadData();
	},[]);

    const loadData = async() => {
        await searchProperties({page: currentPage, numberOfResults: 20})
        await getPropertyTypes().then(res => {
            // console.log()
        })
    }

    useEffect(() => {
        if(propertyTypeWithAttributes){
		    setPropertyTypes(propertyTypeWithAttributes);
        }
	},[propertyTypeWithAttributes]);


    const findValueByAttributeCode = (attribute_code, attributes) => {
        const attributeObject = attributes.find(
            (attribute) => attribute.code === attribute_code
        );
        return attributeObject && attributeObject.value ? attributeObject.value : null;
    }

    

    const handlePageChange = (page) => {
        if (page >= 1 && page <= propertiesResults.pagination.total_pages) {
          setCurrentPage(page);
          let data = formData;
            data.page = page;
            data.numberOfResults = 20;
            data.is_rent = 1;
            searchProperties(data).then(res => {
                // console.log()
            });
        }
    };

    const updateInputValue = (value) => {
        setInputValue(value);
        setFormData({
            ...formData,
            location: value
        });
    }

    // When Click on Location and try to find out location
    const handleInputChange = (event) => {
        
        const { name, value } = event.target;
        setInputValue(value);
        setFormData({
            ...formData,
            [name]: value
        });
        
        // Fetch suggestions from the server when the input changes
        fetchLocations({searchTerm: value}).then(res => {
            if(value.length > 4 && res.payload.data && res.payload.data.length == 0){
                setResultText('No Results Found');
            } else {
                setResultText('');
            }
        });
    };


    // When Change Property type then change values of 
    const handlePropertyTypeChange = (event) => {
        const { name, value } = event.target;
        if(value == 'Residential'){
            setPropertyTypeSubCategory(propertyTypes['residential_properties'])
        } else if(value == 'Commercial'){
            setPropertyTypeSubCategory(propertyTypes['commercial_properties'])
        }
        setFormData({
            ...formData,
            [name]: value
        });
    }

    const handleChange = (event) => {
        
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value
        });
        
    };

    const handleSubmit = async (event) => { 
        const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        setCurrentPage(1);
        let data = formData;
        data.page = 1;
        data.is_rent = 1;
        searchProperties(data).then(res => {
            // console.log()
        });
    }

    return (
        <div>
            <Header/>            

            <section className='pt-5 pb-5 bg-dark'>
                <Container>
                <div className='card p-3 border-0'>
                        <Form onSubmit={handleSubmit}>
                            <Row>
                                <Col md={6} lg={3} className='mb-3'>
                                    <Form.Select aria-label="Propery Status" name="area_unit" onChange={handlePropertyTypeChange}>
                                        <option>Choose</option>
                                        <option value="Hectare">Hectare</option>
                                        <option value="Bigha">Bigha</option>
                                        <option value="Acres">Acres</option>
                                        <option value="Square Yards">Square Yards</option>
                                        <option value="Square Meters">Square Meters</option>
                                        <option value="Square Feet">Square Feet</option>
                                    </Form.Select>
                                </Col>
                                <Col md={6} lg={3} className='mb-3'>
                                    <Form.Control placeholder="Area Unit" name="title" onChange={handleChange} />
                                </Col>
                                <Col md={6} lg={3} className='mb-3'>
                                    <Form.Control placeholder="Size" name="size" onChange={handleChange} />
                                </Col>
                                <Col md={6} lg={3} className='mb-3'>
                                    <Form.Control placeholder="Price" name="price" onChange={handleChange} />
                                </Col>
                                <Col md={6} lg={3} className='mb-3 mb-lg-0'>
                                    <Form.Select aria-label="Propery Status" name="property_type" onChange={handlePropertyTypeChange}>
                                        <option value="">Choose Property Type</option>
                                        <option value="Commercial">Commercial Property</option>
                                        <option value="Residential">Residential Property</option>
                                    </Form.Select>
                                </Col>
                                <Col md={6} lg={3} className='mb-3 mb-lg-0'>
                                    <Form.Select aria-label="Property Type" name="property_type_id" onChange={handleChange}>
                                        <option value="">Property Type</option>
                                        {
                                            propertyTypeSubCategory ?
                                                propertyTypeSubCategory.map((subcategory) => (
                                                <option key={`subcategory${subcategory.property_type_id}`} value={subcategory.property_type_id}>
                                                    {subcategory.title}
                                                </option>
                                                ))
                                            : ''
                                        }
                                    </Form.Select>
                                </Col>
                                <Col md={6} lg={3}>
                                    <Form.Group className='position-relative'  controlId="formGroupLocation">
                                        {/* <Form.Label>Location</Form.Label> */}
                                        <Form.Control type="text" placeholder="Location" name="location" 
                                            value={inputValue} 
                                            onChange={handleInputChange} 
                                            className={ "mb-3"} 
                                            autoCommplete="off"
                                        />
                                        { 
                                        suggestedLocation && suggestedLocation.length > 0 ?
                                            <div className="autocomplete-result">
                                                <ul>
                                                {
                                                    suggestedLocation.map((location, index) => {
                                                        return <li key={`top30Trendingside${index}`} className={activeLocationId == location.location_id ? 'active' : ''} onClick={() => setActiveLocationID(location.location_id)}>
                                                                    
                                                                    <div className="content">
                                                                        <div>
                                                                            <div className="track-name">
                                                                                <div className="text-2" dangerouslySetInnerHTML={{__html: location.location_name}} onClick={() => updateInputValue(location.location_name)}></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                            </li>
                                                    })
                                                    
                                                }
                                                </ul>
                                            </div>
                                        : ''
                                    }
                                    </Form.Group>
                                    
                                </Col>                                <Col xs={1}>
                                    <Button type="submit" variant="primary">Search</Button>
                                </Col>
                            </Row>
                        </Form>
                    </div>
                </Container>
            </section>
            <section className='pt-5 pb-5'>
            {
                propertiesResults && propertiesResults.properties && propertiesResults.properties.length > 0 ?
                <Container>
                    <h5 className="mb-4">{propertiesResults.properties.length} Result</h5>
                    <Row>
                    { 
                        propertiesResults.properties.map((property, propertyIndex) => {
                            return <Col lg={6} xl={4} key={`search-property${propertyIndex}${property.entity_id}`}>
                                        <PropertyCard item={property} />
                                    </Col>
                        })
                    }
                    </Row>
                    <div className="justify-content-center d-flex">
                    {
                        propertiesResults.pagination
                            ? 
                            <CustomPagination 
                                totalPages={propertiesResults.pagination.total_pages} 
                                currentPage={propertiesResults.pagination.page} 
                                onPageChange={handlePageChange} 
                            />
                        : ''
                    }
                    </div>
                </Container>
                : ''
            }
            </section>
            <Footer/>
        </div>
    )
}
function mapStateToProps(state) {
    return {
        propertiesResults: state.property.propertiesResults,
        suggestedLocation: state.location.suggestedLocation,
        propertyTypeWithAttributes: state.propertyType.propertyTypeWithAttributes
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        searchProperties: (post) => dispatch(actions.searchProperties(post)),
        getPropertyTypes: () => dispatch(actionsPropertyType.getPropertyTypes()),
        fetchLocations: (post) => dispatch(locationActions.getAutocompleteLocation(post)),
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(SearchPage);